<template>
<div>
    <div class="topbar">
      <i @click="goHome"></i>
      <!-- <span>{{$t('nav_name')}}</span> -->
      <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li v-for="(item,index) in langList" class="chooseLangUlli" :key="index" @click="setLanguage(item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="changeLangBtn1" @click.stop="goLogin()">{{$t('homepage_button1')}}</div>
      </div>
    </div>
    <div class="banner">
      <div class="forget">
        <div class="forgetPsd" >{{$t('verifySuc_title')}}</div>
        <!-- <span class="line"></span>  -->
       <div class="content">{{$t('verifySuc_txt1')}}</div>
        <button class="signIn" @click="sucess">{{$t('verifySuc_button')}}({{msg}})</button>
      </div>
    </div>
</div>
</template>

<script>
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: 'signSuccess',
  data () {
    return {
      msg:'5s',
      changeLangBox:false,
      langList: I18nUtils.langList,
    }
  },
  mounted () {
      I18nUtils.initLanguage(this);
      this.$http.getAxios('/game/queryUserGameMsg', {
        method: 'post'
        }).then((res) => {
        var res = res.data;
        if(res.code == '0'){
          localStorage.setItem('competeObj',JSON.stringify(res.data))
        }else if(res.code == '5'){
          // this.$router.push({ path:'/signIn'})
        }
      });
      this.start_sms()
  },
  watch: {

  },
  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    
    sucess(){
      window.location.href = process.env.GO_HOME + '#/index'
    },

    start_sms() {
      var count = 1;
      var sum = 5;
      var that = this
      var i = setInterval(function() {
          if (count > 5) {
              window.location.href = process.env.GO_HOME + '#/index'
              clearInterval(i);
          } else {
              that.msg = parseInt(sum - count) + 's';
          }
          count++;
      }, 1000);
    },
    moreLang(){
      this.changeLangBox = !this.changeLangBox;
    },

    goLogin(){
      this.$router.push({ path:'/signIn'})
    },
    goHome(){
      this.$router.push({ path:'/'})
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
.topbar{
    width: 100%;
    height: 60px;
    color: #aaf9fe;
    background: #122346;
    i{
      position: absolute;
      top: 8px;
      left: 40px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      z-index: 99999999999999999;
      background: url('~@/assets/images/bigIcon.png') no-repeat center;
    }
}
.topbar span{
    font-size: 20px;
    line-height: 60px;
    margin-left: 100px;
}
.banner{
    width: 1200px;
    margin: 0 auto;
    .forget{
      width: 500px;
      height: 400px;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
    }
    .forgetPsd{
      font-size: 38px;
      font-weight: 700;
      color: #1b44c5;
    }
    .content{
        width: 350px;
        margin: 0 auto;
        text-align: left;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 35px;
        letter-spacing: 0px;
        color: #ffffff;
        margin-top: 50px;
        margin-bottom: 34px;
    }
}
.signIn{
  width: 461px;
	height: 59px;
	background-color: #2d8c9e;
  border-radius: 29px;
  color: #fff;
  margin: 0 auto;
  border: 0;
  display: block;
  font-size: 20px;
  cursor: pointer;
}
.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
  }
  .changeLangBtn1{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
    margin-right: 20px;
  }
  .s11{
    display: block;
    margin-top: 20px;
    font-size: 18px;
    color: red;
}
.chooseLangUl{
    position: absolute;
    z-index: 111;
    li{
      height: 40px;
      cursor: pointer;
    }
  }
.settingBtn,.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    padding-right: 20px;
  }
  .mainBox1{
    height: 60px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 323223;
}

</style>



// WEBPACK FOOTER //
// src/components/signSuccess.vue